function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "b-824",
  d: "M16.686 0c-.642 0-1.276 0-1.916.003-.536.004-1.067.013-1.608.02a25.632 25.632 0 0 0-3.507.279c-1.158.176-2.28.51-3.327.987a11.297 11.297 0 0 0-2.832 1.857 9.975 9.975 0 0 0-2.062 2.553A9.69 9.69 0 0 0 .34 8.697a18.475 18.475 0 0 0-.313 3.153c-.017.483-.018.967-.027 1.45v36.405c.009.489.01.963.027 1.452.013 1.057.118 2.11.313 3.153a9.669 9.669 0 0 0 1.094 3 9.9 9.9 0 0 0 2.062 2.542 11.01 11.01 0 0 0 2.832 1.856c1.048.48 2.169.814 3.327.994 1.16.171 2.332.264 3.507.278.54.01 1.072.017 1.608.017.64.003 1.274.003 1.916.003h176.05c.629 0 1.268 0 1.897-.003.533 0 1.08-.006 1.613-.017a25.756 25.756 0 0 0 3.5-.278 12.85 12.85 0 0 0 3.34-.994 11.014 11.014 0 0 0 2.83-1.856 10.203 10.203 0 0 0 2.067-2.543 9.688 9.688 0 0 0 1.084-2.999c.195-1.042.304-2.096.325-3.153.006-.49.006-.963.006-1.452.014-.572.014-1.141.014-1.723V15.02c0-.577 0-1.15-.014-1.72 0-.483 0-.967-.006-1.45a19.21 19.21 0 0 0-.325-3.154 9.708 9.708 0 0 0-1.084-2.997c-1.08-1.895-2.793-3.437-4.897-4.41a12.784 12.784 0 0 0-3.34-.987 25.3 25.3 0 0 0-3.5-.279c-.533-.008-1.08-.017-1.613-.02C194.003 0 193.365 0 192.736 0H16.686z"
}), /*#__PURE__*/React.createElement("filter", {
  id: "a-819",
  width: "110.5%",
  height: "134.9%",
  x: "-5.3%",
  y: "-15.9%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  operator: "dilate",
  radius: 0.5,
  result: "shadowSpreadOuter1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1,
  in: "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0.731053359 0 0 0 0 0.731053359 0 0 0 0 0.731053359 0 0 0 0.199898098 0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c-820",
  x1: "60.93%",
  x2: "26.664%",
  y1: "4.948%",
  y2: "71.907%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#00A0FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1%",
  stopColor: "#00A1FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "26%",
  stopColor: "#00BEFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "51%",
  stopColor: "#00D2FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "76%",
  stopColor: "#00DFFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#00E3FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d-821",
  x1: "107.685%",
  x2: "-130.64%",
  y1: "50%",
  y2: "50%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFE000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "41%",
  stopColor: "#FFBD00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "78%",
  stopColor: "#FFA500"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FF9C00"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e-822",
  x1: "86.219%",
  x2: "-50.15%",
  y1: "30.589%",
  y2: "137.439%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FF3A44"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#C31162"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "f-823",
  x1: "-18.754%",
  x2: "42.121%",
  y1: "-13.469%",
  y2: "34.7%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#32A071"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "7%",
  stopColor: "#2DA771"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "48%",
  stopColor: "#15CF74"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "80%",
  stopColor: "#06E775"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#00F076"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(7 6)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#a-819)",
  xlinkHref: "#b-824"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#b-824"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#c-820)",
  d: "M1.322.794a3.117 3.117 0 0 0-.684 2.178v34.425c-.047.79.051 1.41.551 2.13l.164.197 19.316-19.306v-.451L1.43.685l-.108.109z",
  transform: "translate(21.4 17.2)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#d-821)",
  d: "M27.144 26.762l-6.475-6.273v-.44l6.475-6.287.142.075 7.755 4.238c2.211 1.2 2.211 3.174 0 4.389l-7.755 4.298h-.142z",
  transform: "translate(21.4 17.2)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#e-822)",
  d: "M20.58 20.3L1.327 39.685c.09.127.197.24.318.335.79.627 1.841.627 3.105-.091l22.536-13.167L20.58 20.3z",
  transform: "translate(21.4 17.2)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#f-823)",
  d: "M27.286 13.837L4.63.65a2.465 2.465 0 0 0-3.197.095L20.596 20.3l6.69-6.463z",
  transform: "translate(21.4 17.2)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M25.967 18.062L56.53 35.459a2.92 2.92 0 0 1 1.568 2.041 2.748 2.748 0 0 0-1.568-2.261L25.967 17.842c-2.18-1.256-3.936-.22-3.936 2.292v.236c0-2.512 1.756-3.549 3.936-2.308z",
  opacity: 0.25
})), /*#__PURE__*/React.createElement("text", {
  fill: "#000",
  letterSpacing: "0px",
  fontFamily: "StolzlRegular, Stolzl",
  fontSize: 10,
  transform: "translate(7 6)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 69,
  y: 21
}, "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u0432")), /*#__PURE__*/React.createElement("text", {
  fill: "#000",
  letterSpacing: "0px",
  fontFamily: "StolzlMedium, Stolzl",
  fontSize: 20,
  fontWeight: 300,
  transform: "translate(7 6)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 69,
  y: 49
}, "Google Play")));

var SvgGooglePlay = function SvgGooglePlay(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 77,
    viewBox: "0 0 224 77",
    className: "injected-svg",
    style: {
      height: 48,
      width: 145
    },
    "data-src": "/static/images/google-play.svg",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGooglePlay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google-play.4c0ac73c.svg";
export { ForwardRef as ReactComponent };